import React from 'react';
import { getLotReport } from './traceabilityRequests';

export default function useLotReport(path, prnList, reload) {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const lotKey = JSON.stringify((prnList || []).map(lot => lot.LotNbr));
    React.useEffect(() => {
        const controller = new AbortController();
        setData([]);
        setError('');
        setLoading(true);
        getLotReport(path, JSON.parse(lotKey), {}, controller)
            .then(response => {
                if (!controller.signal.aborted) setData(response.data);
            })
            .catch(requestError => {
                if (!controller.signal.aborted) setError(requestError.message);
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });
        return () => controller.abort();
    }, [path, lotKey, reload]);
    return { data, loading, error };
}